import {normalizeReturnToPath} from './returnTo'

const ALLOWED_PREFIXES = ['/', '/home', '/calendar', '/my-classes', '/payments', '/profile', '/regulamin', '/polityka-prywatnosci'] as const

export function resolveCustomerRecoveryPath(value?: string | null, fallback = '/home'): string {
    const safeFallback = normalizeReturnToPath(fallback) ?? '/home'
    const normalized = normalizeReturnToPath(value)
    if (!normalized) return safeFallback

    const queryIndex = normalized.indexOf('?')
    const hashIndex = normalized.indexOf('#')
    const cutIndex =
        queryIndex === -1 ? hashIndex : hashIndex === -1 ? queryIndex : Math.min(queryIndex, hashIndex)
    const pathname = cutIndex === -1 ? normalized : normalized.slice(0, cutIndex)

    const isAllowed = ALLOWED_PREFIXES.some((prefix) =>
        pathname === prefix || (prefix !== '/' && pathname.startsWith(`${prefix}/`))
    )

    return isAllowed ? normalized : safeFallback
}
